import * as Sentry from '@sentry/browser'
import { v4 as uuidv4 } from 'uuid'

// Current request's trace ID
let currentTraceId: string | null = null

// Generate new trace ID for a request
export function generateTraceId(): string {
  currentTraceId = uuidv4()
  // Set globally so auto-captured errors also get it
  Sentry.setTag('struxhub_trace_id', currentTraceId)
  return currentTraceId
}

// Get current trace ID
export function getCurrentTraceId(): string | null {
  return currentTraceId
}
